// creates a singleton of browser history for future app-wide use

import { createBrowserHistory } from 'history'

export default createBrowserHistory()
